<template>
  <div class="tw-flex tw-items-stretch">
    <div class="tw-grow tw-min-w-0 tw-flex tw-flex-col tw-gap-2">
      <div
        v-if="!slim"
        class="tw-grow tw-relative tw-flex tw-flex-row tw-items-start tw-gap-2"
      >
        <slot name="top-left"></slot>
        <div
          class="
            tw-grow tw-space-y-1 tw-overflow-hidden tw-min-h-6
            empty:tw-hidden
          "
        >
          <slot name="heading"></slot>
        </div>
        <!-- Cap the actions height (tw-h-4) and centre them, so fixed-height
             buttons revealed on hover overflow the line, centred on the author
             text, instead of growing this row and pushing the card content
             below. -->
        <div class="tw-h-4 tw-flex tw-items-center tw-whitespace-nowrap">
          <slot name="actions"></slot>
        </div>
      </div>
      <div
        v-if="!slim"
        class="tw-grow tw-relative tw-flex tw-flex-col tw-gap-2 empty:tw-hidden"
      >
        <slot name="before-message" />
      </div>
      <div
        class="tw-grow tw-relative tw-flex tw-flex-col tw-gap-2"
        :class="opacityClass"
      >
        <div
          v-if="!read"
          class="
            tw-absolute
            tw-start-[-8px]
            tw-inset-y-0
            tw-w-0.5
            tw-bg-sf-danger-light-1
          "
          data-testid="message-unread-indicator"
        />
        <slot name="body"></slot>
        <!-- In slim/presentation mode, show actions on hover with a background overlay -->
        <div
          v-if="slim"
          class="
            actions-container
            tw-absolute tw-top-0 tw-right-0 tw-whitespace-nowrap tw-hidden
            group-[:hover:not(:has([data-commentid]:hover))]:tw-flex
            tw-items-center tw-gap-1
          "
          :class="theme.actionsOverlay"
        >
          <slot name="actions"></slot>
        </div>
      </div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { commsTheme } from '@app/shared/comms-theme'

interface Props {
  hasOpacity?: boolean
  read?: boolean
  slim?: boolean
}

const props = defineProps<Props>()

const theme = commsTheme()

const opacityClass = computed(() => ({
  'tw-opacity-80': props.hasOpacity,
}))
</script>
